
// @ts-nocheck
import locale_de_46json_1c1ccdff from "#nuxt-i18n/1c1ccdff";
import locale_en_46json_80467b57 from "#nuxt-i18n/80467b57";

export const localeCodes =  [
  "de",
  "en"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_1c1ccdff",
      load: () => Promise.resolve(locale_de_46json_1c1ccdff),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_80467b57",
      load: () => Promise.resolve(locale_en_46json_80467b57),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      name: "DE",
      iso: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "EN",
      iso: "en-US",
      dir: "ltr",
      files: [
        {
          path: "D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: true,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    name: "DE",
    iso: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "EN",
    iso: "en-US",
    dir: "ltr",
    files: [
      {
        path: "D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/